import { useEffect, useState } from "react";
import { visionURL } from "../config/environment";
import Jsona from "jsona";
import JsonApiService from "../services/jsonapiService";
import visionCallService from "../services/visionCallService";

const dataFormatter = new Jsona();

const pinnedRepositoryApiService = async () =>
  new JsonApiService("repository_pins", {
    baseUrl: `${visionURL}/admin_console/api/content`,
    credentials: "include"
  });

export const useRepositoryPins = () => {
  const [isLoadingPins, setIsLoadingPins] = useState(false);
  const [repositoryPins, setRepositoryPins] = useState([]);
  const createPinnedRepository = async newPinnedRepositoryData => {
    const service = await pinnedRepositoryApiService();
    let newPin = await service
      .create(
        visionCallService.serializeRequestBody(
          {
            ...newPinnedRepositoryData,
            relationshipNames: ["user", "library"]
          },
          "pinnedRepository",
          ["user", "library"]
        )
      )
      .then(response => response.json());
    return dataFormatter.deserialize(newPin);
  };

  const deletePinnedRepository = async pinnedRepositoryId => {
    const service = await pinnedRepositoryApiService();
    return service.delete(pinnedRepositoryId);
  };

  useEffect(() => {
    const fetchRepositoryPins = async () => {
      setIsLoadingPins(true);
      const service = await pinnedRepositoryApiService();
      const response = await service.all().then(response => response.json());
      setIsLoadingPins(false);
      setRepositoryPins(dataFormatter.deserialize(response));
    };
    fetchRepositoryPins();
  }, []);

  return {
    deletePinnedRepository,
    createPinnedRepository,
    isLoadingPins,
    repositoryPins
  };
};
